module.exports = __webpack_public_path__ + "static/img/ninja-can-08.f482fe09.png";